export default __webpack_public_path__ + "static/media/messages.62db2cc2.svg";